<div class="row">
    <ng-container *ngIf="orderEditModalPageOne">
        <div class="col-12 my-5">
            <h3 class="text-center">Enter Verification Code</h3>
        </div>
        <div class="col-12">
            <ng-otp-input #ngOtpInput (onInputChange)="changeOtp($event)" [config]="configTwo"></ng-otp-input>
            <div class="my-3">
                <h4>
                    <p class="text-center">code expires in <span class="text-danger text-bold ">{{timeToVerify * 1000 |
                            date:'mm:ss'}}</span></p>
                </h4>
            </div>
        </div>
        <div class="col-12 my-4 text-end">
            <button accessControl
            module="SalesTransaction"
            access=3 class="btn btn-link fs-4" [disabled]="timeToVerify > 0" (click)="resendOtpEditOrderFunc()">RESEND OTP</button>
        </div>
        <div class="col-12 text-right">
            <button accessControl
            module="SalesTransaction"
            access=3 class="btn btn-pink w-100 eatos-submit-btn" (click)="nextPageFunc()" [disabled]="!buttonApprove">APPROVE</button>
        </div>
    </ng-container>
    <ng-container *ngIf="orderEditModalPageTwo && !orderEditModalPageThree">
        <div class="col-12 mt-5 mb-2">
            <h3 class="f-14 fw-600">Select Transaction to edit</h3>
        </div>
        <div class="col-12" *ngFor="let transaction of paymentReceipt.transactionIds; let i = index">
            <div class="row" (click)="selectTransactionEditOrderFunc(transaction , paymentReceipt, i)"
                [ngClass]="!transaction.transactionSelected? 'selectTran' :'selectTran2'">
                <div class="col-10 text-start">
                    <span class="text-bold f-14 fw-500">Transaction ID</span>
                    <div id="buttonTransaction" class="mt-3"
                        style="height: 31px;font-size: 22.5px;	letter-spacing: -0.56px;	line-height: 31px;">
                        <span *ngIf="(transaction.transactionTypeId == 16 ||
                                                                transaction.transactionTypeId == 17 ||
                                                                transaction.transactionTypeId == 18 ||
                                                                transaction.transactionTypeId == 19 )">
                            <img style="height: 27.84px;width: 44.02px;"
                                *ngIf="(transaction.extraFields.cardType | lowercase) == 'mastercard'"
                                src="../../../../../../assets/images/trnsaction-card-images/Mastercard.png">
                            <img style="height: 27.84px;width: 44.02px;"
                                *ngIf="(transaction.extraFields.cardType | lowercase) == 'amex'"
                                src="../../../../../../assets/images/trnsaction-card-images/AmEx.png">
                            <img style="height: 27.84px;width: 44.02px;"
                                *ngIf="(transaction.extraFields.cardType | lowercase) == 'discvr'"
                                src="../../../../../../assets/images/trnsaction-card-images/Discover.png">
                            <img style="height: 27.84px;width: 44.02px;"
                                *ngIf="(transaction.extraFields.cardType | lowercase) == 'discover'"
                                src="../../../../../../assets/images/trnsaction-card-images/Discover.png">
                            <img style="height: 27.84px;width: 44.02px;"
                                *ngIf="(transaction.extraFields.cardType | lowercase) == 'visa'"
                                src="../../../../../../assets/images/trnsaction-card-images/Visa.png">
                            <span
                                style="height: 31px;	width: 208px;font-size: 22.5px;	letter-spacing: -0.56px;line-height: 31px;"
                                *ngIf="transaction.extraFields.cardType != 'UnknownCardType'">**** **** ****
                                {{transaction.extraFields.maskedPAN | slice:-4}}</span>
                        </span>
                    </div>
                </div>
                <div class="col-2 text-end fw-600 f-14">
                    {{transaction.transactionNumber}}
                    <div id="buttonTransaction" class="mt-3">
                        {{currency}}{{transaction.transactionAmount | number : '1.2-2'}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 my-5 text-end">
                    <button accessControl
                    module="SalesTransaction"
                    access=3 id="buttonTransaction" class="btn btn-pink eatos-submit-btn"
                        (click)="selectTransactionEditOrderFunc(transaction,paymentReceipt,i)">
                        SELECT AND EDIT TIPS
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="orderEditModalPageTwo && orderEditModalPageThree">
        <div class="col-12">
            <div class="form-group">
                <label>Employee Name</label>
                <div class="arrow-down-main">
                    <select class="form-control" id="employeeIds" [(ngModel)]="userSelected"
                        (ngModelChange)="changeValueSelectFunc($event)">
                        <option disabled value="">
                            Select Employee
                        </option>
                        <option *ngFor="let employee of employees" value="{{employee.id}}">
                            {{employee.name}}
                        </option>
                    </select>
                    <i class="fa-solid fa-chevron-down"></i>
                </div>
            </div>
            <div class="form-group my-3">
                <label>Tip</label>
                <input class="form-control text-start" #currency (ngModelChange)="change(currency)" currencyMask
                [(ngModel)]="tipAmount" [options]="{ prefix: '$', decimal: '.' }" placeholder="$0.00" />
            </div>
        </div>
        <div class="col-12 my-4">
            <button accessControl
            module="SalesTransaction"
            access=3 class="btn btn-pink eatos-submit-btn w-100" [disabled]="chageLoader" (click)="changeTipFunc()">
                <span *ngIf="chageLoader">Please wait...</span>
                <span *ngIf="!chageLoader">CHANGE</span>
            </button>
        </div>
    </ng-container>
</div>
